export const ARROW_DOWN_KEY = 'ArrowDown';

export const ARROW_UP_KEY = 'ArrowUp';

export const ENTER_KEY = 'Enter';

export const ESCAPE_KEY = 'Escape';

export const SPACE_KEY = ' ';

export const FIRST_OPTION_INDEX = 0;

export const NO_FOCUSED_OPTION_INDEX = -1;

export const OPTION_INDEX_STEP = 1;
